import axios from "axios";

export async function initCsrf() {
  const baseUrl = process.env.VUE_APP_API_URL.replace(/\/api$/, "");

  await axios.get(`${baseUrl}/sanctum/csrf-cookie`, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  });
}
